/*============ SignIn-Out Controller ==============*/
angular
    .module('vppApp')
    .controller('signInNoticeController', signInNoticeController);

signInNoticeController.$inject = ['$window', '$scope', '$rootScope', '$location', 'vppConfig', 'apiFactory', '$state', '$http', 'AuthenticationService', 'DTMTrackerService', '$stateParams', '$cookies', 'CreateAccountService'];

function signInNoticeController($window, $scope, $rootScope, $location, vppConfig, apiFactory, $state, $http, AuthenticationService, DTMTrackerService, $stateParams, $cookies, CreateAccountService) {
    var service = {};
    $scope.hideMe = false;
    $scope.showSignInNotice;
    $scope.ssoUrl;
    $scope.url;
    $scope.registrationNoticeSiteName;
    $scope.registrationNoticelogoPath;
    $scope.siteCode = vppConfig.folderPath;
    $scope.siteName = vppConfig.siteNames[$scope.siteCode];

    $scope.goToSignIn = function () {
        apiFactory.getSsoUrl().then(function (response) {
            $scope.ssoUrl = response.data;
        });
        $scope.siteCode = vppConfig.folderPath;
        // $scope.manageNoticeCookie();
        window.location.href = $scope.ssoUrl;
    }

    $scope.goToCreateAccount = function () {  //TODO:not used
        $scope.manageCreateAccountCookie();
        // $scope.manageNoticeCookie();
        $state.go("create-account");
    }

    // Removed 11/17/2020
    // $scope.manageNoticeCookie = function() {
    //     if($scope.showSignInNotice){
    //         var date = new Date();
    //         var expirationDate = new Date(date.setMonth(date.getMonth()+6));
    //         $cookies.put('showSignInNotice', false, {expires: expirationDate});
    //     }
    // }

    $scope.manageCreateAccountCookie = function () {
        var date = new Date();
        var expirationDate = new Date(date.setMonth(date.getMonth() + 6));
        $cookies.put('createAccountDirect', false, { expires: expirationDate });
    }

    $scope.goToSsoUrl = function () {
        $scope.toggleModal();
        $window.location.href = $scope.url;
    }


    $scope.accountMigrationSubmit = function (user) {
        $scope.responsePending = true;
        var body = {
            email: user.email,
            siteCode: $scope.siteCode,
            language: 'english'
        };

        // $scope.manageNoticeCookie();

        apiFactory.postDetermineRegistrationRoute(body).then(function (response) {
            $scope.responsePending = false;

            CreateAccountService.setAccountMigrationDetails(response.data);
            CreateAccountService.setAccountMigrationUserInput(body);
            if (response.data.url) {
                //common login or register url
                $scope.url = response.data.url;
                if (response.data.registrationType === "Silent") {
                    $scope.toggleModal('accountMigration');
                } else if (response.data.registrationType === "Lite") {
                    //toggles login to iam url
                    $scope.toggleModal('accountRegistrationMigration');
                    $scope.manageCreateAccountCookie();  //createAccountDirect = false
                } else if (response.data.registrationType === "Registration") {
                    $scope.getRelatedContent();
                    $scope.toggleModal('accountRegistrationNotice');
                    $scope.manageCreateAccountCookie();  //createAccountDirect = false
                } else if (response.data.registrationType === "IDme-Registration") {
                    $scope.getRelatedContent();
                    $state.go('sign-in');
                    $scope.manageCreateAccountCookie();  //createAccountDirect = false
                }
                else {
                    //common login or register url
                    $window.location.href = $scope.url;
                }
            }
        }, function errorCallBack(response) {
            $scope.responsePending = false;
            $scope.serverError = response.data.errors;
        });
    }

    $scope.goToForgotPasswordUrl = function () {
        apiFactory.getForgotPasswordURL($scope.siteCode, 'english').then(function (response) {
            $window.location.href = response.data;
        })
    }

    $scope.getRelatedContent = function getRelatedContent() {
        $http.get(vppConfig.accountRegistrationNoticeContentPath).then(function successCallback(response) {
            $scope.registrationNoticelogoPath = response.data.logoPath;
            $scope.registrationNoticeSiteName = response.data.siteName;
        });
    }

}
